import { render, staticRenderFns } from "./ClientHistoryTable.vue?vue&type=template&id=1368deb2&scoped=true"
import script from "./ClientHistoryTable.vue?vue&type=script&lang=js"
export * from "./ClientHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./ClientHistoryTable.vue?vue&type=style&index=0&id=1368deb2&prod&lang=scss&scoped=true"
import style1 from "./ClientHistoryTable.vue?vue&type=style&index=1&id=1368deb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368deb2",
  null
  
)

export default component.exports